import type { SVGProps } from 'react'

export const CalendarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.3332 1.66669V5.00002" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.66667 1.66669V5.00002" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.5 7.49998H17.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8333 3.33331H4.16667C3.24583 3.33331 2.5 4.07915 2.5 4.99998V15.8333C2.5 16.7541 3.24583 17.5 4.16667 17.5H15.8333C16.7542 17.5 17.5 16.7541 17.5 15.8333V4.99998C17.5 4.07915 16.7542 3.33331 15.8333 3.33331Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.84406 10.6075C5.72906 10.6075 5.63573 10.7008 5.63656 10.8158C5.63656 10.9308 5.72989 11.0242 5.84489 11.0242C5.95989 11.0242 6.05323 10.9308 6.05323 10.8158C6.05323 10.7008 5.95989 10.6075 5.84406 10.6075"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0111 10.6075C9.89605 10.6075 9.80272 10.7008 9.80355 10.8158C9.80355 10.9308 9.89688 11.0242 10.0119 11.0242C10.1269 11.0242 10.2202 10.9308 10.2202 10.8158C10.2202 10.7008 10.1269 10.6075 10.0111 10.6075"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.1776 10.6075C14.0626 10.6075 13.9692 10.7008 13.9701 10.8158C13.9701 10.9308 14.0634 11.0242 14.1784 11.0242C14.2934 11.0242 14.3867 10.9308 14.3867 10.8158C14.3867 10.7008 14.2934 10.6075 14.1776 10.6075"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.84406 13.9408C5.72906 13.9408 5.63573 14.0341 5.63656 14.1491C5.63656 14.2641 5.72989 14.3575 5.84489 14.3575C5.95989 14.3575 6.05323 14.2641 6.05323 14.1491C6.05323 14.0341 5.95989 13.9408 5.84406 13.9408"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0111 13.9408C9.89605 13.9408 9.80272 14.0341 9.80355 14.1491C9.80355 14.2641 9.89688 14.3575 10.0119 14.3575C10.1269 14.3575 10.2202 14.2641 10.2202 14.1491C10.2202 14.0341 10.1269 13.9408 10.0111 13.9408"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
